import { Mail, Phone, MapPin } from 'lucide-react';

export const contactInfo = [
  {
    icon: Mail,
    title: 'Email',
    value: 'dagiteferi2011@gmail.com',
    href: 'mailto:dagiteferi2011@gmail.com'
  },
  {
    icon: Phone,
    title: 'Phone',
    value: '+251 920 362324',
    href: 'tel:+251920362324'
  },
  {
    icon: MapPin,
    title: 'Location',
    value: 'Adiss Ababa, Ethiopia',
    href: 'https://maps.app.goo.gl/iCWq14Bj8RVkELv56'
  }
];

export const availableServices = [
  'AI/ML ',
  'Full-stack Development', 
  'Back-end Development',
  'Data science',
];
